import { render } from "./ProcedureHeader.vue?vue&type=template&id=42019ea3&scoped=true"
import script from "./ProcedureHeader.vue?vue&type=script&lang=js"
export * from "./ProcedureHeader.vue?vue&type=script&lang=js"

import "./ProcedureHeader.vue?vue&type=style&index=0&id=42019ea3&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42019ea3"]])

export default __exports__